<form [formGroup]="changeUsernameForm" (ngSubmit)="onSubmitChangeUsernameForm()" class="wrapper-account-page">
  <span class="title-settings-page">
    {{'ACCOUNT.change_username' | translate}}
  </span>
  <span class="subtitle-settings-page">
    {{'ACCOUNT.changing_username_can_be_performed_once_every' | translate}} 90 {{'ACCOUNT.days'| translate}}.
  </span>
  <span class="subtitle-settings-page">
    {{'ACCOUNT.the_update_will_take_effect_immediately' | translate}}
  </span>
  <div class="wrapper-input" [ngClass]="{'error': changeUsernameForm.controls['username'] | formControlErrorMessages: null : formTriedToSubmit}">
    <span class="label-input">
      {{'GENERAL.username' | translate}}
    </span>
    <div class="custom-input">
      <input type="text" formControlName="username" placeholder="Enter your username">
    </div>
    <div *ngIf="changeUsernameForm.controls['username'] | formControlErrorMessages: null : formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{changeUsernameForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
    </div>
  </div>
  <div class="wrapper-submit-settings">
    <button type="submit" class="custom-btn custom-btn--primary">
      <span>{{'GENERAL.save_changes' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </div>
</form>
